// @flow
import {
    FETCH_CLIENT_CONFIG_START,
    FETCH_CLIENT_CONFIG_COMPLETE,
    INJECT_CLIENT_CONFIG
} from 'common/constants/actionTypes';
import { clientConfig } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { injectError } from './error';

export default class ClientConfigActions {
    static fetchClientConfig({ clientId }: { clientId: string }) {
        const params = {
            clientId
        };

        return dispatch => {
            return new Promise((resolve, reject) => {
                dispatch(ClientConfigActions.startFetchingClientConfig());
                clientConfig
                    .fetch(params)
                    .then(clientConfig => {
                        resolve(clientConfig);
                        dispatch(
                            ClientConfigActions.injectClientConfig(
                                clientConfig,
                                params
                            )
                        );
                    })
                    .catch(error => {
                        reject(error);
                        dispatch(
                            ClientConfigActions.completeFetchingClientConfig()
                        );
                        if (error instanceof ApiError) {
                            dispatch(injectError(error));
                        } else {
                            throw error;
                        }
                    });
            });
        };
    }

    static startFetchingClientConfig(): Object {
        return {
            type: FETCH_CLIENT_CONFIG_START
        };
    }

    static completeFetchingClientConfig(): Object {
        return {
            type: FETCH_CLIENT_CONFIG_COMPLETE
        };
    }

    static injectClientConfig(clientConfig, params): Object {
        return {
            type: INJECT_CLIENT_CONFIG,
            response: clientConfig,
            params
        };
    }
}
